<template>
  <div>
    <v-container>
      <v-row>
        <div class="affiliates-container">
          <div class="affiliates-count">
            <label>{{ $t('starAssignment.label.assignAffiliates.title') }}</label>
          </div>
          <div>
            <v-tooltip right>
              <template #activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="dialog = true"
                  color="#e9d4f7"
                  rounded
                  fab
                  dark
                  class="mx-4 custom-btn"
                >
                  <v-icon class="custom-icon">mdi-account-plus-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('starAssignment.label.assignAffiliates.title') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-row>
      <br />
      <div v-if="showTable">
        <v-row class="table" v-if="checkedAffiliates.length">
          <v-col cols="12">
            <v-simple-table
              class="table-cell small-table"
              style="align-self: center"
            >
              <thead>
                <tr>
                  <th
                    class="table-cell"
                    style="
                      color: #6e17a5;
                      text-align: center;
                      font-weight: 500;
                      font-size: 16px;
                    "
                  >
                    {{ $t('starAssignment.label.table.userZen') }}
                  </th>
                  <th
                    class="table-cell"
                    style="
                      color: #6e17a5;
                      text-align: center;
                      font-weight: 500;
                      font-size: 16px;
                    "
                  >
                    {{ $t('starAssignment.label.table.amountZen') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="affiliate in checkedAffiliates"
                  :key="affiliate.userId"
                >
                  <td class="table-cell">
                    {{ affiliate.firstName }} {{ affiliate.middleName }}
                    {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                  </td>

                  <td class="table-cell">
                    <input
                      type="number"
                      min="0"
                      :value="assignedStars[affiliate.userId]?.quantity || ''"
                      class="inputCantidad"
                      @input="updateAssignedStars(affiliate.userId,$event.target.value)"
                      placeholder="0"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </div>

      <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card class="container-model">
          <button class="close-button" @click="closeDialog">
            <span class="small-x">X</span>
          </button>
          <v-col cols="12" md="12" sm="6">
            <img
              src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
              class="custom-img"
            />
          </v-col>
          <h2 class="custom-title">{{ $t('starAssignment.label.search') }}</h2>
          <h3 class="custom-text">{{ $t('starAssignment.label.maxAffiliates') }}</h3>
          <br />
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" class="search">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                v-model="searchTerm"
                outlined
                class="search"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-list v-if="searchTerm" class="scrollable-list">
            <v-list-item-group v-if="filteredAffiliates.length">
              <v-list-item
                v-for="affiliate in filteredAffiliates"
                :key="affiliate.userId"
              >
                <v-list-item-action>
                  <v-checkbox
                    v-model="selectedItems"
                    :value="affiliate.userId"
                    color="secondary"
                    @change="toggleAffiliateSelection(affiliate)"
                    :disabled="
                      selectedItems.length >= 10 &&
                      !selectedItems.includes(affiliate.userId)
                    "
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ affiliate.firstName }} {{ affiliate.middleName }}
                    {{ affiliate.lastName }}
                    {{ affiliate.secondLastName }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('starAssignment.label.notFoundAffiliate') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-container class="selected-affiliates">
            <div v-if="checkedAffiliates.length">
              <h4>{{ $t('starAssignment.label.checkedAffiliates') }}</h4>
              <ul>
                <div class="affiliates-grid">
                  <div class="column">
                    <div class="affiliate-item">
                      <li
                        v-for="affiliate in firstFiveAffiliates"
                        :key="affiliate.userId"
                      >
                        {{ affiliate.firstName }} {{ affiliate.middleName }}
                        {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                      </li>
                    </div>
                  </div>
                  <div class="column">
                    <div class="affiliate-item">
                      <li
                        v-for="affiliate in secondFiveAffiliates"
                        :key="affiliate.userId"
                      >
                        {{ affiliate.firstName }} {{ affiliate.middleName }}
                        {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                      </li>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </v-container>
          <v-card-actions>
            <v-btn
              :disabled="isConfirmEnabled"
              rounded
              @click="saveChanges"
              color="primary">
              {{ $t('button.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template>
        <div v-if="showTable">
          <div style="height: 50px" v-if="this.checkedAffiliates.length > 0">
            <v-btn
              :disabled="!isSendButtonEnabled"
              fixed
              bottom
              right
              rounded
              @click="confirmSubmit()"
              color="primary"
            >
              {{ $t('button.assign') }}
            </v-btn>
          </div>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  USERSADMIN_M,
  ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES,
  GET_STARASSIGNMENT_SEARCHAFFILIATES,
} from "@/views/users_admin/store/types/types.js";

import {
  STARASSIGNMENT_M,
  ACTION_POST_ZEN_STAR,
} from "@/views/star_assignment/store/types/types.js";

export default {
  data() {
    return {
      dialog: false,
      selectedItems: [],
      searchTerm: "",
      affiliates: [],
      formData: {},
      assignedStars: {},
      checkedAffiliates: [],
      selectedAffiliatesData: [],
      confirmDialog: false,
      showTable: false,
    };
  },
  methods: {
    closeDialog() {
      this.searchTerm = "";
      this.dialog = false;
    },

    confirmSubmit() {
      Swal.fire({
        title: i18n.t('starAssignment.label.assignStar'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: i18n.t('button.saveAssign.text'),
        cancelButtonText: i18n.t('button.cancel.text'),
        confirmButtonColor: "#6E17A5",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const data = this.sendDataToParent();
            this.postStarAssignmentZen(data);
            this.closeDialog();
            this.$emit("saved", "Los datos se han guardado exitosamente.");
          } catch (error) {
            console.error("Error al guardar los datos:", error);
          }

          this.confirmDialog = false;
        } else {
          Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
        }
      });
    },

    ...mapActions({
      getActionSearchAffiliates: `${USERSADMIN_M}${ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES}`,
      postStarAssignmentZen: `${STARASSIGNMENT_M}${ACTION_POST_ZEN_STAR}`,
    }),

    toggleAffiliateSelection(affiliate) {
      const index = this.checkedAffiliates.findIndex(
        (a) => a.userId === affiliate.userId
      );
      if (index === -1) {
        this.checkedAffiliates.push(affiliate);
      } else {
        this.checkedAffiliates.splice(index, 1);
        this.$delete(this.assignedStars, affiliate.userId);
      }
    },
    validateAffiliatesCount(affiliateId, quantity) {
      const maxStars = 100;
      if (quantity > maxStars) {
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.limitAssign.title'),
          text: i18n.t('starAssignment.label.limitAssignZen.text').replace('maxStars', maxStars)
        });

        const exceso = quantity - maxStars;
        this.assignedStars[affiliateId].quantity -= exceso;
      }
    },

    updateAssignedStars(affiliateId, quantity) {
      if (!this.assignedStars[affiliateId]) {
        this.$set(this.assignedStars, affiliateId, { quantity: 0 });
      }

      // Validar y limpiar decimales (punto o coma)
      if (quantity !== "" && quantity !== "0") {
        if (/[.,]/.test(quantity)) {
          // Remover todo después del punto o coma
          quantity = quantity.split(/[.,]/)[0];
        }
      }

      this.assignedStars[affiliateId].quantity =
        quantity === "" || quantity === "0" ? "" : Number(quantity);
      
      this.validateAffiliatesCount(affiliateId, quantity);
    },

    async fetchAffiliates() {
      if (this.searchTerm.length >= 3) {
        try {
          await this.getActionSearchAffiliates(this.searchTerm);
        } catch (error) {
          console.error("Error fetching affiliates:", error);
        }
      }
    },

    saveChanges() {
      const newSelectedAffiliates = this.searchAffiliates.filter((affiliate) =>
        this.selectedItems.includes(affiliate.userId)
      );
      this.selectedAffiliatesData = [
        ...new Set([...this.selectedAffiliatesData, ...newSelectedAffiliates]),
      ];

      this.showTable = true;
      this.dialog = false;
      this.searchTerm = "";
    },

    prepareDataForSubmit() {
      return {
        listData: Object.keys(this.assignedStars).map((affiliateId) => {
          const { quantity } = this.assignedStars[affiliateId];
          return {
            destinationUserId: Number(affiliateId),
            amoung: Number(quantity)
          };
        }),
      };
    },

    sendDataToParent() {
      const dataForSubmit = this.prepareDataForSubmit();
      if (!dataForSubmit || !Array.isArray(dataForSubmit.listData)) {
        throw new Error(
          i18n.t('starAssignment.label.errorAssign')
        );
      }
      return dataForSubmit;
    },
  },

  computed: {
    ...mapGetters({
      searchAffiliates: [`${USERSADMIN_M}${GET_STARASSIGNMENT_SEARCHAFFILIATES}`]
    }),

    filteredAffiliates() {
      if (this.searchTerm.length < 3) {
        return [];
      }
      const searchTerms = this.searchTerm.toLowerCase().split(/\s+/);

      return this.searchAffiliates
        .filter((affiliate) => {
          const fullName = `${affiliate.firstName} ${
            affiliate.middleName || ""
          } ${affiliate.lastName} ${
            affiliate.secondLastName || ""
          }`.toLowerCase();
          return searchTerms.every((term) => fullName.includes(term));
        })
        .map((affiliate) => ({
          ...affiliate,
          isSelected:
            this.selectedItems.includes(affiliate.userId) ||
            this.selectedAffiliatesData.some(
              (a) => a.userId === affiliate.userId
            ),
        }));
    },

    selectedAffiliates() {
      return this.searchAffiliates.filter((affiliate) =>
        this.selectedItems.includes(affiliate.userId)
      );
    },

    firstFiveAffiliates() {
      return this.checkedAffiliates.slice(0, 5);
    },
    secondFiveAffiliates() {
      return this.checkedAffiliates.slice(5, 10);
    },

    isConfirmEnabled() {
      return this.checkedAffiliates.every((affiliate) => {
        const data = this.formData[affiliate.userId];
        this.showTable = false;
        return data && data.quantity > 0;
      });
    },
    isSendButtonEnabled() {
      return this.checkedAffiliates.every((affiliate) => {
        const assignedData = this.assignedStars[affiliate.userId];
        return (
          assignedData && assignedData.quantity > 0
        );
      });
    },
  },

  watch: {
    searchTerm(newTerm) {
      if (newTerm.length >= 3) {
        this.fetchAffiliates();
      }
    },
  },
};
</script>

<style scoped>
.assign {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 300px;
  padding: 16px;
}

.affiliates-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.affiliates-grid {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.affiliates-count {
  color: #ff7900;
  margin-left: 14px;
}

.custom-btn {
  width: 40px;
  height: 40px;
}

.custom-icon {
  font-size: 22px;
  color: #6e17a5 !important;
}

.container-model {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-size: 3vh;
  color: #6e17a5;
}

.small-x {
  font-size: smaller;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  text-align: center;
}

.custom-text {
  font-size: 16px;
  color: #000000;
  font-weight: 300;
  text-align: center;
  margin: 2px;
}

.search {
  align-items: center;
  width: 450px;
}

.scrollable-list {
  max-height: 200px;
  width: 450px;
  overflow-y: auto;
  border: 1px solid #ff7900;
}

.selected-affiliates {
  margin-top: 10px;
  margin-left: 0;
  text-align: left;
  justify-self: left;
}

.selected-affiliates h4 {
  font-weight: bold;
  color: #4a148c;
  text-align: left;
  font-size: 16px;
  padding-left: 40px;
}

.selected-affiliates ul {
  text-align: left;
  color: #000000;
  padding-left: 60px;
  padding-right: 50px;
}

.selected-affiliates li {
  font-size: 14px;
  color: #000000;
  text-align: left;
}

.table-cell {
  text-align: center;
  border: 1px solid #ff7900;
}

.small-table {
  width: 600px;
  align-items: flex-start;
}

.table {
  margin-top: 20px;
}

.inputCantidad {
  text-align: center;
  width: 50px;
  border: 1px solid #6e17a5;
  border-radius: 5px;
}

.inputCantidad {
  text-align: center;
  width: 50px;
  border: 1px solid #6e17a5;
  border-radius: 5px;
}

@media screen and (max-width: 600px) {
  .cardStyle {
    padding: 8px;
  }

  .custom-title {
    font-size: 24px;
  }

  .custom-text {
    font-size: 14px;
  }

  .v-card-title {
    font-size: 1rem;
  }

  .scrollable-list {
    max-height: 150px;
    width: 340px;
    overflow-y: auto;
    border: 1px solid #ff7900;
  }

  .search {
    align-items: center;
    width: 340px;
  }

  .selected-affiliates {
    margin-top: 10px;
    padding: auto;
    text-align: left;
    justify-self: left;
    padding-left: 6px;
    padding-right: 0px;
  }

  .selected-affiliates h4 {
    font-weight: bold;
    color: #4a148c;
    text-align: left;
    font-size: 14px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .selected-affiliates ul {
    text-align: left;
    font-size: 10px;
    padding-left: 12px;
    padding-right: 0px;
  }
}
</style>
